import { nonEmptyArray } from 'fp-ts';
import { NonEmptyArray } from 'fp-ts/NonEmptyArray';
import { CalendarEvent } from '@mews-commander/types';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Stack } from '@optimus-web/core';
import { LocalizedDateTimeFromUtc } from '../localization';
import { SpacedColon } from '../typography';

type CalendarEventListItemProps = Omit<CalendarEvent, 'id'>;

const CalendarEventListItem = ({ name, startUtc, endUtc }: CalendarEventListItemProps) => (
    <Stack vertical>
        <div>{name}</div>
        <div>
            <LocalizedText textKey={TextKey.FromDate} />
            {SpacedColon}
            <LocalizedDateTimeFromUtc utcString={startUtc} />
        </div>
        <div>
            <LocalizedText textKey={TextKey.ToDate} />
            {SpacedColon}
            <LocalizedDateTimeFromUtc utcString={endUtc} />
        </div>
    </Stack>
);

const renderCalendarEventListItem = nonEmptyArray.map(({ id, ...other }: CalendarEvent) => (
    <CalendarEventListItem key={id} {...other} />
));

interface CalendarEventListProps {
    calendarEvents: NonEmptyArray<CalendarEvent>;
}

export const CalendarEventList = ({ calendarEvents }: CalendarEventListProps) => (
    <Stack spacing="100" vertical>
        {renderCalendarEventListItem(calendarEvents)}
    </Stack>
);
